/*
 * @Description: 请输入当前文件描述
 * @Author: @Xin (834529118@qq.com)
 * @Date: 2020-09-29 19:35:22
 * @LastEditTime: 2020-09-29 20:24:22
 * @LastEditors: @Xin (834529118@qq.com)
 */
import Vue from 'vue'
import App from '@/App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import '@/plugins/axiosExtend'
import store from '@/store'

import '@/plugins/routerGuards'
import router from '@/router'

import directive from '@/directive'

// 按需加载组件
import '@/utils/importElementComponent'

import './assets/iconsFont/iconfont.css'

import './assets/common.less'

import { plugin } from 'vue-function-api'

import dataV from '@jiaminghi/data-view'

// import TreeView from 'vue-json-tree-view'

import echarts from 'echarts'

Vue.use(ElementUI)
Vue.prototype.$echarts = echarts

Vue.use(plugin)

Vue.use(dataV)

// Vue.use(TreeView)

Vue.config.productionTip = false

// 全局注册自定义指令
Object.entries(directive).forEach(([key, value]) => void Vue.directive(key, value))

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
